import { ArabicEach, findRecursive } from '@/mm/utils.js'

export function washData_productImgText2(walkedNode) {
  const ProNode = findRecursive(
    walkedNode.list,
    (item) => item._type === 'button_text_icon_1',
    'list'
  )
  if (ProNode) {
    if (!ProNode.actions[0].config['文字设计'].find((item) => item === 'self_textInput')) {
      ProNode.actions[0].config['文字设计'].unshift('self_textInput')
    }
    if (!ProNode.actions[0].config['按钮设计'].find((item) => item === 'icon_color')) {
      ProNode.actions[0].config['按钮设计'].unshift('icon_color')
    }
    if (!ProNode.actions.find((item) => item === 'translate')) {
      ProNode.actions.push('translate')
    }
  }

  let ArabicRule = [
    {
      flag: 'product_title_flag',
      dataType: ['design'],
      onlyEnglish: ['title_textAlign'],
      englishTitleLeft: ['left'],
      englishTitleRight: ['right']
    },
    {
      flag: 'product_content_title_flag',
      dataType: ['design'],
      onlyEnglish: ['title_textAlign'],
      englishTitleLeft: ['left'],
      englishTitleRight: ['right']
    },
    {
      flag: 'product_content_flag',
      dataType: ['design'],
      onlyEnglish: ['title_textAlign'],
      englishTitleLeft: ['left'],
      englishTitleRight: ['right']
    }
  ]
  ArabicEach(walkedNode, ArabicRule)
}
